import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IndicadoresService {
  private readonly apiURL = environment.api_proyecciones;
  private headers = new HttpHeaders().append('Content-Type', 'application/json');
  constructor(
    private http: HttpClient,
  ) { }

  public getGrupos(): Observable<any>{
    const apiURL = this.apiURL + 'api/grupo/list';
    return this.http.get(apiURL, { headers: this.headers });
  }
  public postGrupo(name):Observable<any>{
    const grupo = {
      nombre: name
    }
    const body = JSON.stringify(grupo);
    const apiURL = this.apiURL + 'api/grupo/create';
    return this.http.post(apiURL, body, { headers: this.headers});
  }
  //Indicadores asociados a un pais, recibe clavepais
  public getIndicadoresAll(pais): Observable<any>{
    const p = {
      clavepais: pais,
    }
    const body = JSON.stringify(p);
    const apiURL = this.apiURL + 'api/indicador/list';
    return this.http.post(apiURL, body, { headers: this.headers});
  }
  //Indicadores asociados a una plantilla, recibe el id de la plantilla
  public getIndicadorTmp(templateid):Observable <any>{
    const id = {
      templateid: templateid,
    }
    const body = JSON.stringify(id);
    const apiURL = this.apiURL + 'api/indicador/list';
    return this.http.post(apiURL, body, { headers: this.headers});
  }
  public postIndicadorTemplate(ind): Observable<any>{
    const body = JSON.stringify(ind);
    const apiURL = this.apiURL + 'api/indicador/create';
    return this.http.post(apiURL, body, { headers: this.headers});
  }
  public postIndicadorUniverso(ind): Observable<any>{
    const indicador = {
      grupoid: ind.grupoid,
      clavepais: ind.pais,
      indicador: ind.nombre,
      descripcion: ind.descrip,
      formula: {
        numerador: ind.numerador,
        denominador: ind.denominador
      },
    }
    const body = JSON.stringify(indicador);
    const apiURL = this.apiURL + 'api/indicador/create';
    return this.http.post(apiURL, body, { headers: this.headers});
  }
  public postFormula(ind): Observable<any>{
    const body = JSON.stringify(ind);
    const apiURL = this.apiURL + 'api/tempind/update_formula';
    return this.http.post(apiURL, body, { headers: this.headers});
  }
  
}
